import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { camps } from './../../../../models/models.generated'

@Component({
    selector: 'app-camp-list-row',
    templateUrl: './camp-list-row.component.html',
    styleUrls: ['./camp-list-row.component.scss'],
    standalone: false
})
export class CampListRowComponent implements OnInit {

    @Input() public item: camps.CampDefinitionInfo;

    constructor(private router: Router) { }

    ngOnInit() {
    }

    public onDetailsView(): void {
        this.router.navigate(['camps/' + this.item.id + '/details']);
    }

    public onEnrollmentView(): void {
        this.router.navigate(['camps/' + this.item.id + '/enrollment']);
    }

    public onBookingsView(): void {
        this.router.navigate(['camps/' + this.item.id + '/booking']);
    }
}
